<ng-container *ngIf="displaySubbanner">
  <eyrus-header-banner  
  [userType]="userType" 
  [bannerType]="bannerType" 
  [showClose]="bannerShowClose"
  [account]="userAccount"
  (closed)="bannerClosed($event)">
  </eyrus-header-banner>
</ng-container>

<header class="main-header navbar navbar-expand-md __fixed-top" #header>

  <div class="gs keep-lay align-items-center w-100 relative-container h-100">

    <div class="lay icon-area-lay hide-md hide-lg">
      <div class="menu-holder" id="menu-trigger">
        <i class="ae ae-menu" (click)="openMenu()" *ngIf="!subview"></i>
        <i class="ae ae-left back-arrow floating-back" (click)="goBack()" *ngIf="subview"></i>
      </div>
    </div>

    <div class="lay">
      <div class="header-title">
        <h3 [innerHtml]="title"></h3>
      </div>
      <div class="lay hide-xs hide-sm">
        <eyrus-breadcrumbs></eyrus-breadcrumbs>
      </div>
    </div>

    <div class="lay icon-area-lay hide-md hide-lg">
      <div class="helper-icon" 
        *ngIf="iconOptions?.icon" 
        (click)="runAction()"
        [ngClass]="{'with-container': iconOptions.container }">
        <div [ngClass]="{'icon-container': iconOptions.container }">
          <i class="fas ae {{ iconOptions?.icon }}"></i>
        </div>
      </div>
    </div>

    <div class="lay icon-area-lay hide hide-xs hide-sm">
      <div class="notifications-menu">
        <i class="ae ae-help"></i>
      </div>
    </div>

    <div class="lay __border-left menu-dropdown-lay hide-xs hide-sm">
      <!-- <div class="tmp-user-info">
        <span class="__firstname">{{ currentUser?.user?.firstName }}</span>
        <span class="__lastname">{{ currentUser?.user?.lastName }}</span>
      </div> -->
      <div class="header-account-menu">
        <button mat-button [matMenuTriggerFor]="menu" 
          (menuOpened)="opened = true"
          (menuClosed)="opened = false">
          <div class="__user-info">
            <span class="__firstname">{{ currentUser?.user?.firstName }} {{ currentUser?.user?.lastName }}</span>
            <span class="__lastname"> {{ currentCompany?.accountName }} </span>
          </div>
          <div class="arrow-icon" [ngClass]="{up: opened, down: !opened }">
          </div>
        </button>
        <mat-menu #menu="matMenu" 
          panelClass="custom-menu"
          xPosition="before" 
          backdropClass="top__mat-menu" >
          <div class="__main-into">
            <b>{{ currentUser?.user?.firstName }} {{ currentUser?.user?.lastName }}</b>
          </div>
          <div class="custom-menu">
            <div class="divider"></div>
            <div class="items-container">
              <ng-container  *ngFor="let account of currentUserAccounts; let last = last" >
                <button mat-menu-item
                  class="p-l-xs p-r-xs"
                  [ngClass]="{ 'active-btn': sameAccount(account?.accountId) }"
                  (click)="switchAccount(account)">
                  <i class="icon-btn ae ae-g-contractor m-r-sm m-l-sm"></i>
                  {{account.accountName}} 
                </button>
                <div *ngIf="!last" class="divider"></div>
              </ng-container>
            </div>

          </div>
        </mat-menu>
      </div>

    </div>

  </div>

  <ng-content></ng-content>
</header>